import React from 'react'
import PropTypes from 'prop-types'
import {
  RowFlexPropTypes,
  JustifyContentPropTypes,
  AlignItemsPropTypes,
  AlignContentPropTypes,
  NoGuttersPropTypes
} from './types'
import { filterInvalidProps, getClassNames } from './utils'

const classMap = {
  xsFlex: 'flex',
  smFlex: 'flex-sm',
  mdFlex: 'flex-md',
  lgFlex: 'flex-lg',
  xlFlex: 'flex-xl',
  xsJustifyContent: 'justify-content',
  smJustifyContent: 'justify-content-sm',
  mdJustifyContent: 'justify-content-md',
  lgJustifyContent: 'justify-content-lg',
  xlJustifyContent: 'justify-content-xl',
  xsAlignItems: 'align-items',
  smAlignItems: 'align-items-sm',
  mdAlignItems: 'align-items-md',
  lgAlignItems: 'align-items-lg',
  xlAlignItems: 'align-items-xl',
  xsAlignContent: 'align-content',
  smAlignContent: 'align-content-sm',
  mdAlignContent: 'align-content-md',
  lgAlignContent: 'align-content-lg',
  xlAlignContent: 'align-content-xl',
  noGutters: 'no-gutters'
}

const Row = props => {
  const { children, ...otherProps } = filterInvalidProps(props, classMap)
  const extraClass = ['row']
  const classNames = getClassNames(props, classMap, extraClass)

  return (
    <div {...otherProps} className={classNames}>
      {children}
    </div>
  )
}

Row.propTypes = {
  /**
   * Rows are horizontal groups of columns that ensure your columns are lined up properly
   * Only columns may be immediate children of rows
   * https://v4-alpha.getbootstrap.com/layout/grid/#how-it-works
   */
  children: PropTypes.node,
  xsFlex: RowFlexPropTypes,
  smFlex: RowFlexPropTypes,
  mdFlex: RowFlexPropTypes,
  lgFlex: RowFlexPropTypes,
  xlFlex: RowFlexPropTypes,
  xsJustifyContent: JustifyContentPropTypes,
  smJustifyContent: JustifyContentPropTypes,
  mdJustifyContent: JustifyContentPropTypes,
  lgJustifyContent: JustifyContentPropTypes,
  xlJustifyContent: JustifyContentPropTypes,
  xsAlignItems: AlignItemsPropTypes,
  smAlignItems: AlignItemsPropTypes,
  mdAlignItems: AlignItemsPropTypes,
  lgAlignItems: AlignItemsPropTypes,
  xlAlignItems: AlignItemsPropTypes,
  xsAlignContent: AlignContentPropTypes,
  smAlignContent: AlignContentPropTypes,
  mdAlignContent: AlignContentPropTypes,
  lgAlignContent: AlignContentPropTypes,
  xlAlignContent: AlignContentPropTypes,
  noGutters: NoGuttersPropTypes
}

export { Row }



// WEBPACK FOOTER //
// ./src/components/Grid/Row.js